import React, { useState, useEffect } from 'react';
import { notificationService } from '../../../services/notificationService';
import { Toast as ToastType } from '../../../types/ui.types';
import Toast from './Toast';
import './ToastContainer.css';

const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState<ToastType[]>([]);

  useEffect(() => {
    const unsubscribe = notificationService.subscribe((newToasts) => {
      setToasts(newToasts);
    });

    return unsubscribe;
  }, []);

  const handleClose = (id: string) => {
    notificationService.remove(id);
  };

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={handleClose} />
      ))}
    </div>
  );
};

export default ToastContainer;
